import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { createSkipInterceptContext } from 'src/app/core/interceptors/generic-error-handling-interceptors';
import { environment } from 'src/environments/environment';
import { Queue, QueueMigrateResponse, QueueUpdateRequest, QueueUser } from '../models';

@Injectable()
export class QueuesService {

  constructor(private http: HttpClient) { }

  getQueues(pbxId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues`);
  }

  public updateQueue(pbxId: number, queue: Queue){
    return this.http.put(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/${queue.id}`, this.convertFromQueueToQueueUpdateRequest(queue));
  }

  restartQueues(pbxId: number) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/restart`, '');
  }

  logoutUsersQueue(pbxId: number) {
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/users/logout`, '');
  }

  logoutUserQueue(pbxId: number, userId: number) {
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/users/${userId}/logout`, '');
  }

  loginUserQueue(pbxId: number, userId: number) {
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/users/${userId}/login`, '');
  }

  resolveConflictsQueue(pbxId: number, queueId: number) {
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/${queueId}/resolve-conflicts`, '');
  }

  public recreateQueue(pbxId: number, queueId: number) {
    const customContext = createSkipInterceptContext();
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/queues/${queueId}/recreate`, null,
      customContext ? {context: customContext} : undefined
    )
  }

  public migrateQueues(pbx_id: number, ids: number[], destination_module: string): Observable<QueueMigrateResponse> {
    const params = new HttpParams({
      fromObject:{
        destination_module,
        pbx_id,
        ids: ids.toString()
      }
    });
    return this.http.put<QueueMigrateResponse>(`${environment.apiEndpoint}/api/v1/pbxes/queues/module/migrate`, null, { params })
  }


  private convertFromQueueToQueueUpdateRequest(queue: Queue): QueueUpdateRequest {
    return {
      id: queue.id,
      name: queue.name,
      user_ids: queue.users.map((user: QueueUser) => user.id),
      extension_number: queue.extension_number,
      agent_ring_timeout: queue.agent_ring_timeout,
      connection_timeout: queue.connection_timeout,
      media_id: queue.moh.id,
      is_recreatable: queue.is_recreatable,
      user_strategy: queue.user_strategy
    }
  }
}
